import { render, staticRenderFns } from "./SurveyQuestionsScreen.vue?vue&type=template&id=513e9f6e&scoped=true"
import script from "./SurveyQuestionsScreen.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionsScreen.vue?vue&type=script&lang=js"
import style0 from "./SurveyQuestionsScreen.vue?vue&type=style&index=0&id=513e9f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513e9f6e",
  null
  
)

export default component.exports